export default __webpack_public_path__ + "static/media/speech-bubble.81e8e972.webp";